<template>
  <booking-home />
</template>

<script>
import BookingHome from "@/components/3pl/Operations/Bookings/Home/Index";
export default {
  components: {
    BookingHome,
  },
  mounted() {
    this.$_addTwakTo();
    this.$_removeTwakTo('display: block !important');
  },
  beforeDestroy() {
    this.$_removeTwakTo('display: none !important');
  }
};
</script>

<style></style>
